import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "video",
    "overlay",
    "playIcon",
    "pauseIcon",
    "unmuteIcon",
    "muteIcon",
  ];

  connect() {
    console.log("🔥 Video Player Stimulus Controller is actively running!");
    this.videoTarget.controls = false;
    this.syncMuteIcon();
  }

  togglePlay(event) {
    // Stop the event from bubbling up to the carousel and stop double-fires
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (this.videoTarget.paused) {
      this.videoTarget.play();
      this.playIconTarget.classList.add("hidden");
      this.pauseIconTarget.classList.remove("hidden");
      this.overlayTarget.classList.add("opacity-0");
      this.overlayTarget.classList.remove("opacity-100");
    } else {
      this.videoTarget.pause();
      this.pauseIconTarget.classList.add("hidden");
      this.playIconTarget.classList.remove("hidden");
      this.overlayTarget.classList.remove("opacity-0");
      this.overlayTarget.classList.add("opacity-100");
    }
  }

  toggleMute(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    this.videoTarget.muted = !this.videoTarget.muted;
    this.syncMuteIcon();
  }

  syncMuteIcon() {
    if (this.videoTarget.muted) {
      this.unmuteIconTarget.classList.add("hidden");
      this.muteIconTarget.classList.remove("hidden");
    } else {
      this.muteIconTarget.classList.add("hidden");
      this.unmuteIconTarget.classList.remove("hidden");
    }
  }
}
